module.exports = __webpack_public_path__ + "img/public_navi_combo.91fa0abe.svg";